import React, { Component } from "react";
import '../Styles/About.css'
import photo02 from '../Images/photo02.jpeg'

export default class About extends Component {
  render() {
    return (
      <section className="about" id="about">
        <div 
          className="about-container"
          data-aos="zoom-out"
          data-aos-duration="1000"
        >
        <div className="photo-container">
          <div className="aux-div" />
          <div className="photo-content">
            <img 
              src={ photo02 }
              alt="my-face"
              className="photo"
            />
          </div>
        </div>
        <div className="description-about">
          <h1 className="title-about">Sobre</h1>
          <p className="text-description-about">
            Fascinado por tecnologia e inovação, sou um desenvolvedor web full-stack formado pela escola de programação
            <a 
                href="https://www.betrybe.com/formacao-desenvolvimento-web"
                className="trybe-link"
                target="_blank"
                rel="noreferrer"
              > Trybe.
              </a> 
          </p>
          <br />
          <p className="text-description-about">            
            Desenvolvo projetos de front-end utilizando HTML, CSS, JavaScript, React e Redux, e projetos back-end com Docker, NodeJS, TypeScript, ExpressJS, JWT, MySQL e MongoDB. Além disso, utilizo bibliotecas de testes, como Jest, React Testing Library e Mocha para o desenvolvimento orientado a testes. Também trabalho com sistemas de controle de versão, como o Git, e metodologias ágeis, como Scrum e Kanban. Eu constantemente busco evoluir minhas habilidades, aprendendo novas linguagens como Python e melhorando meu conhecimento em inglês.
          </p>
          <br />
          <p className="text-description-about">
            Minha formação inicial é em Engenharia Agronômica, e possuo uma pós-graduação em Fertilidade do Solo e Nutrição de Plantas, ambas pela Faculdade Campo Real, em Guarapuava, Paraná.
          </p>
        </div>
        </div>
      </section>
    )
  }
}